import React from 'react';

import { Center, Flex } from '@chakra-ui/react';
import { Link as GatsbyLink } from 'gatsby';

import { Button } from '../Button/Button';
import { Heading } from '../Heading/Heading';
import { LazySvg } from '../LazySvg/LazySvg';
import { Markdown } from '../Markdown/Markdown';

export const IconCard = ({ title, text, iconName, link, ...rest }) => {
	return (
		<Flex as="article" direction="column" alignItems="center" p={5} bg="secondary.50" {...rest}>
			<Center
				position="relative"
				w={20}
				h={20}
				top={-10}
				flexShrink={0}
				border="6px solid white"
				borderRadius="full"
				bg="secondary.100"
			>
				<LazySvg color="secondary.500" w={10} h={10} name={iconName} />
			</Center>
			<Flex mt={-4} direction="column" h="100%" textAlign="center">
				<Heading as="h3" fontSize="xl" fontWeight="semibold" color="secondary.700">
					{title}
				</Heading>
				<Markdown content={text} mt={3} flexGrow={1} fontSize="lg" color="secondary.700" />
				{link?.title && link?.urlPath && (
					<Button as={GatsbyLink} to={link.urlPath} mt={3} py={3} minW="50%" alignSelf="center">
						{link.title}
					</Button>
				)}
			</Flex>
		</Flex>
	);
};
